import React, { Component } from 'react'
// import Select from 'components/theme/Select'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { list, read, create } from 'actions/data'
import Button from 'components/theme/Button'

class EmailSelect extends Component {
	componentDidMount() {
		this.props.list('email/valid_sending_addresses', 'address')
		this.props.read(null, 'email/verify_my_address_status', null, 'none')
	}

	render() {
		// const options = Object.values(
		// 	this.props?.['email/valid_sending_addresses'] || {},
		// ).map((obj) => ({ label: obj.address, value: obj.address }))
		const myAddress = this.props?.['email/verify_my_address_status']

		const options = Object.values(
			this.props?.['email/valid_sending_addresses'] || {},
		).map((obj) => {
			const color = obj?.status === 'success' ? '#000' : 'gray'

			return (
        <li
          style={
            obj?.address === myAddress?.address
              ? {
                  fontWeight: 'bold',
                  position: 'relative',
                  color,
                  marginBottom: 15,
                }
              : { color, marginBottom: 15 }
          }
        >
          <span style={{ marginRight: 12 }}>
            {obj?.address}
            {obj?.status !== 'success' ? ` (unverified)` : ''}
          </span>
          {obj?.address === myAddress?.address && (
            <Button
              // style={{ marginLeft: 12 }}
              onClick={() =>
                this.props.create({
                  entity: null,
                  entityType: 'email/verify_my_address',
                  noReturnValue: true,
                  hasSchema: false,
                  snackbarMessage: `A verification email has been sent to ${myAddress.address}`,
                })
              }
              variant="contained"
              color="primary"
              size="small"
            >
              {obj?.status === 'success' || obj?.status === 'pending'
                ? 'Re-send'
                : 'Send'}{' '}
              verification email
            </Button>
          )}
        </li>
      )
		})

		return (
			<ul
				style={{
					border: '1px solid rgba(0, 0, 0, 0.23)',
					borderRadius: 25,
					listStyle: 'none',
					padding: 20,
				}}
			>
				{options}
			</ul>
		)

		// return (
		// 	<Select
		// 		value={
		// 			myAddress
		// 				? { label: myAddress.address, value: myAddress.address }
		// 				: null
		// 		}
		// 		options={options}
		// 		styles={this.props.customStyles}
		// 	/>
		// )
	}
}

export default connect(
	(state) => ({
		'email/valid_sending_addresses':
			state.data?.['email/valid_sending_addresses'],
		'email/verify_my_address_status':
			state.data?.['email/verify_my_address_status'],
	}),
	(dispatch) => bindActionCreators({ list, read, create }, dispatch),
)(EmailSelect)
